<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    v-if="loaded"
    :setLoading="setLoading"
    ref="invoice-credit"
    class="invoice-credit"
    :backButtonRoute="backButtonRoute"
    :paging="false"
    :validationSummary="validationSummary"
  >
  </TransactionTemplate>
</template>

<script>
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import SalesFormulas from "@/_helpers/formulas/sales-formulas.js";
import { InvoiceCreditService } from "../../_services/api/sales/invoice-credit.service.js";
import {
  getDefaultCustomerSettings,
  getDefaultUserSettings,
  getFactorByCode,
} from "../../_store/helpers";
import CheckBox from "devextreme/ui/check_box";
import { alert } from "devextreme/ui/dialog";
import { TransactionService } from "../../_services/api/templates/transactions.services";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import { CommonStorage, FeatureStorage } from "../../_services/storage";
import { AlmondcoDespatchDataService } from "../../_services/api/sales/almondco-despatch-data.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { CompanyService } from "../../_services/api/accounts/company.service";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("Invoice Credit >>> ", arguments);
}

const {
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  // calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
} = SalesFormulas;

let saveModel = {
  TransactionFlag: "",
  OriginalInvoiceCode: "",
  BranchCode: "",
  ConsignmentNo: "",
  CurrencyCode: "",
  CustomerCode: "",
  CustomerDeliveryAddressLineNo: "",
  DateDue: "",
  DateIn: "",
  DateChanged: undefined,
  DeliveryAddressCompanyName: "",
  DeliveryAddressCountry: "",
  DeliveryAddressPostcode: "",
  DeliveryAddressState: "",
  DeliveryAddressStreetLine1: "",
  DeliveryAddressStreetLine2: "",
  DeliveryAddressSuburb: "",
  DivisionCode: "",
  ExchangeRate: "",
  OrderNo: "",
  SalesOrderCode: "",
  SalesOrderTypeCode: "",
  SalesRepresentativeCode: "",
  TaxTotal: 0,
  Total: 0,
  UserComment1: "",
  UserComment2: "",
  UserComment3: "",
  UserComment4: "",
  UserComment5: "",
  UserComment6: "",
  UserComment7: "",
  UserComment8: "",
  UserComment9: "",
  UserComment10: "",
  UserComment11: "",
  UserComment12: "",
  UserComment13: "",
  UserComment14: "",
  UserComment15: "",
  UserComment16: "",
  UserComment17: "",
  UserComment18: "",
  UserComment19: "",
  UserComment20: "",
  ResupplyOrder: false,
  InvoiceCreditDetails: [
    {
      OriginalInvoiceLineNo: "",
      AddDiscPriceGroupCode: "",
      AddDiscPricingMethod: "",
      AddDiscPricingMethodValue: "",
      AddDiscSalesUMPrice: "",
      AddDiscStockUMPrice: "",
      BatchStockTolerance: "",
      CalculatedDiscPcnt: "",
      CustomerProduct: "",
      DiscFXLineTotal: "",
      DiscLineTotal: "",
      FXLineTotal: "",
      IsCommentVisible: "",
      IsPrimeCostItem: "",
      ItemCode: "",
      ItemType: "",
      LineTotal: "",
      NetFXLineTotal: "",
      NetLineTotal: "",
      PriceGroupCode: "",
      PriceGroupSalesUMPrice: "",
      PriceGroupStockUMPrice: "",
      PricingMethod: "",
      PricingMethodValue: "",
      SalesUM: "",
      SalesUMConversion: "",
      SalesUMCost: "",
      SalesUMFXPrice: "",
      SalesUMInvoiceConversion: "",
      SalesUMIsVariable: "",
      SalesUMManufacturedCost: "",
      SalesUMNetFXPrice: "",
      SalesUMNetPrice: "",
      SalesUMPrice: "",
      SalesUMPromotionNetPrice: "",
      SalesUMQty: "",
      SalesUMStandardCost: "",
      SalesUMStandardPrice: "",
      Comment: "",
      DiscPcnt: "",
      StockUMNetPrice: "",
      StockUMPrice: "",
      StockUMQty: 1,
      TaxCode: "",
      StockUM: "",
      StockUMFXPrice: "",
      StockUMStandardPrice: "",
      TaxableFXLineTotal: "",
      TaxableLineTotal: "",
      TaxFXLineTotal: "",
      TaxLineTotal: "",
      TaxRate: "",
      WetFreightAdjustment: "",
      WetFXFreightAdjustment: "",
      WetFXLineTotal: "",
      WetLineTotal: "",
      WetPcnt: "",
      WriteOff: "",
      InvoiceProductBatches: [
        {
          BatchNo: "",
          StockUMBatchQty: "",
          SalesUMBatchQty: "",
          SalesUMInvoiceConversion: "",
          SupplierCode: "",
          StockUMQty: undefined,
          SalesUMQty: undefined,
        },
      ],
    },
  ],
};

let setBackRoute = undefined;

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      BulkInclude: false,
      DateIn: {
        min: undefined,
        max: undefined,
      },
      backButtonRoute: undefined,
      disabledReSupply: false,
      almondcoQCData: undefined,
      dataIndex: undefined,
      BaseCurrency: undefined,
      CurrencyCode: undefined,
      headerFormInstance: undefined,
      CompanyCurrency: undefined,
      validationSummary: [],
    };
  },

  async created() {
    await this.$store.dispatch(
      "defaultUserSettings/setDefaultCompanyBranchDivision",
    );
    this.BaseCurrency = getDefaultUserSettings().CurrencyCode;
    await this.$store.dispatch("screenFactors/getFactors", [619, 665]);
    if (FeatureStorage.checkPermission("AlmondcoDespatchData", "create")) {
      await InvoiceCreditService.getInvoiceById(this.baseView.id).then(
        async (invoice) => {
          if (invoice.data.value.length > 0) {
            var data = invoice.data.value[0];
            await AlmondcoDespatchDataService.checkQCData(data.DeliveryNoteCode)
              .then((res) => {
                if (res.data.value.length > 0) {
                  res.data.value.forEach((element) => {
                    element.DespatchDate = new Date(
                      element.DespatchDate.replace("Z", ""),
                    );
                    element.PackedOnDate = new Date(
                      element.PackedOnDate.replace("Z", ""),
                    );

                    element.CartonCreditQty = -Math.abs(
                      element.CartonOutstandingQty,
                    );
                    element.DespatchCreditWeight = -Math.abs(
                      element.TotalWeight,
                    );

                    element.DespatchData = true;
                    element.CheckInclude = true;
                  });
                  this.almondcoQCData = res.data.value;
                }
              })
              .catch((err) => {
                if (err) this.$logger.debug("error", err);
              });
          }
        },
      );
    }

    this.CheckStockWriteOff =
      getFactorByCode(619).Factorc == "Y" ? true : false;
    this.setDateInValidation();
    this.initialized();

    if (CommonStorage.getItems("go_back_route"))
      this.backButtonRoute = CommonStorage.getItems("go_back_route");
    else this.backButtonRoute = setBackRoute;
  },

  beforeRouteEnter(to, from, next) {
    if (from.fullPath != "/") {
      setBackRoute = from.fullPath;
      CommonStorage.saveItems("go_back_route", from.fullPath);
    }
    next();
  },
  mounted() {},

  computed: {
    ...mapGetters({ getDataContext: ["dataContext/getDataContext"] }),
    dataChangedIndex() {
      return this.$store.state.dataContext.dataChangedIndex;
    },
    getScreenJson() {
      var screenJson = {
        title: "Credit Invoice",
        endpoint: {
          primary: this.headerEndpoint,
          postProcess: this.PostProcessHeaderData,
          select: this.getSelectOptions,
        },
        headerData: {
          headerFormVisible: true,
          headerFormSplitView: true,
          headerToolbar: {
            screenName: "Credit Invoice Review",
            pdf: this.baseView.mode == "review",
            email: this.baseView.mode == "review",
            audit: true,
            status: true,
            notes: false,
            commentsAsForm: true,
            save: this.baseView.mode !== "review",
            saveCallback: this.saveData,
            commentsTitle: "Credit Comments",
            pdfPreviewMenuItems: {
              makeDisabled: (dataModel, previewPdfs) => {
                var items = [];
                var x = { ...dataModel };

                previewPdfs.forEach((element) => {
                  if (
                    x.DeliveryNote == 0 &&
                    element.ScreenLayoutApplicationFeatureCode ===
                      "ReportDeliveryNote"
                  )
                    element.disabled = true;
                  else element.disabled = false;

                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    Parameters: element.Parameters,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },

            customButtons: [
              {
                label: "save",
                icon: "..",
                type: " ",
                click: "",
                menu: [
                  {
                    label: "Credit Comments",
                    clickAction: "",
                  },
                ],
              },
            ],

            emailMenuItems: {
              referenceNoField: "Code",

              makeDisabled: (dataModel, emailRecords) => {
                var items = [];

                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                  },
                ],
              },
            ],
            orderComments: {
              keepComments: true,
              dataField: "SalesOrderTypeCode",
              endpoint: "SalesOrderType",
              toMatch: [
                "UserComment1",
                "UserComment2",
                "UserComment3",
                "UserComment4",
                "UserComment5",
                "UserComment6",
                "UserComment7",
                "UserComment8",
                "UserComment9",
                "UserComment10",
                "UserComment11",
                "UserComment12",
                "UserComment13",
                "UserComment14",
                "UserComment15",
                "UserComment16",
                "UserComment17",
                "UserComment18",
                "UserComment19",
                "UserComment20",
              ],
            },
            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [],
              },
            ],

            toolbarAfterFormItems: [
              {
                screenField: "Inactive",
                dataField: "ResupplyOrder",
                editorType: "dxSwitch",
                label: {
                  text: "Re-Supply Order",
                },
                disabled: this.disabledReSupply,
              },
            ],
          },
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  label: {
                    text: "Name",
                  },
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "DeliveryAddressStreetLine1",
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "DeliveryAddressStreetLine2",
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressSuburb",
                  dataField: "DeliveryAddressSuburb",
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressState",
                  dataField: "DeliveryAddressState",
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressPostcode",
                  dataField: "DeliveryAddressPostcode",
                  allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressCountry",
                  dataField: "DeliveryAddressCountry",
                  allowUpdate: false,
                },
              ],
            },
          ],
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        displayFormat: "dd MMM yyyy",
                        min: this.DateIn.min,
                        max: this.DateIn.max,
                      },
                      required: this.baseView.mode != "review",
                    },
                    {
                      dataField: "OrderNo",
                      screenField: "CustPO",
                      editorOptions: {
                        onKeyDown: (e) => {
                          if (!this.exchangeRateEditable) this.moveOnKeyDown(e);
                        },
                        maxLength: 20,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      cssClass: "deliver-to",
                      items: [
                        {
                          screenField: "DeliverTo",
                          dataField: "DeliveryAddressCompanyName",
                          label: {
                            text: "Deliver To",
                          },
                          allowUpdate: false,
                          editorOptions: {
                            tabIndex: -1,
                          },
                        },
                        {
                          screenField: "DeliveryCompanyView",
                        },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "ExchangeRate",
                          dataField: "ExchangeRate",
                          cssClass: "exchange-rate",
                          editorOptions: {
                            readOnly: !this.exchangeRateEditable,
                            onValueChanged: this.onExchangeValueChanged,
                            step: 0,
                            tabIndex: !this.exchangeRateEditable
                              ? -1
                              : undefined,
                            onKeyDown: (e) => {
                              this.moveOnKeyDown(e);
                            },
                          },
                        },
                        {
                          dataField: "CurrencyCode",
                          label: {
                            text: "Currency",
                            visible: false,
                          },
                          editorOptions: {
                            tabIndex: -1,
                            readOnly: true,
                          },
                        },
                      ],
                    },
                  ],
                },

                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "BranchDescription",
                      screenField: "Branch",
                      allowUpdate: false,
                      editorOptions: {
                        tabIndex: -1,
                      },
                    },
                    {
                      dataField: "DivisionDescription",
                      screenField: "Division",
                      allowUpdate: false,
                      editorOptions: {
                        tabIndex: -1,
                      },
                    },
                    {
                      dataField: "SalesOrderTypeDescription",
                      screenField: "OrderType",
                      allowUpdate: false,
                      editorOptions: {
                        tabIndex: -1,
                      },
                    },
                    {
                      screenField: "SalesRep",
                      allowUpdate: false,
                      editorOptions: {
                        tabIndex: -1,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: "Code",
                text: "Credit #",
              },
              customFunction: (data) => {
                let title = "";

                if (data.SalesOrderCode) {
                  if (this.baseView.mode == "review") {
                    title = `Credit #${data.Code} for Invoice #${data.OriginalInvoiceCode} for Sales Order #${data.SalesOrderCode}`;
                  } else {
                    title = `Create Credit for Invoice #${data.Code} for Sales Order #${data.SalesOrderCode}`;
                  }

                  return title;
                } else {
                  if (this.baseView.mode == "review") {
                    return `Credit #${data.Code}`;
                  } else {
                    return `Create Credit for Invoice #${data.Code}`;
                  }
                }
              },
            },
            secondary: {
              dataField: "CustomerName",
              text: undefined,
            },
          },
          formContentReady: (e) => {
            if (e && this.baseView.mode != "review" && this.loaded)
              this.onFormContentReady(e);
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "InvoiceDetail",
              filter: ["InvoiceCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              expand: "SaleItem($select=BatchStockTolerance,ItemCode)",
              postProcessCallback: this.PostProcess,
              select: [
                "InvoiceCode",
                "ItemCode",
                "ItemDescription",
                "TaxCode",
                "SalesUM",
                "SalesUMOrderQty",
                "IsBatchProduct",
                "SalesUMNetFXPrice",
                "TaxableFXLineTotal",
                "TaxFXLineTotal",
                "FXLineTotal",
                "ProductCategory1Code",
                "ProductCategory2Code",
                "ProductCategory3Code",
                "ProductCategory4Code",
                "ProductTypeCode",
                "ItemType",
                "Comment",
                "SalesUMQty",
                "SalesUMCreditedQty",
                "LineNo",
                "SalesUMInvoiceConversion",
                "SalesUMFXPrice",
                "WetPcnt",
                "SalesTaxPcnt",
                "SalesUMIsVariable",
                "SalesUMConversion",
                "SalesUMPrice",
                "SalesUMNetPrice",
                "PackSize",
                "StockUMQty",
                "StockUMFXPrice",
                // "StockUMNetFXPrice",
                "StockUMPrice",
                "StockUMNetPrice",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No Invoice Lines",
                message: "All lines on the invoice have been credited.",
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: true,
          },
          childColumns: this.getChildColumns,
          columns: [
            {
              visible: this.baseView.mode !== "review",
              screenField: "CheckInclude",
              label: "",
              allowEditing: true,
              defaultValue: this.checkIncludeValue,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: this.baseView.mode !== "review",
              width: 40,
              editorOptions: {
                onKeyDown: (e, cellInfo) => {
                  if (e.keyCode == 9 && e.shiftKey && cellInfo.rowIndex == 0) {
                    e.preventDefault();
                    if (this.exchangeRateEditable) {
                      this.headerFormInstance
                        .getEditor("ExchangeRate")
                        .instance()
                        .focus();
                    } else {
                      this.headerFormInstance
                        .getEditor("OrderNo")
                        .instance()
                        .focus();
                    }
                  }
                },
              },
              // fixed: true,
              // fixedPosition: "left",
            },
            {
              screenField: "Product",
              label: "Product / Account",
              allowEditing: false,
              dataField: "ItemCode",
              gridDataField: "ItemCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "ItemDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "ItemCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ItemCode",
                  label: "Item Code",
                },
                {
                  dataField: "ItemDescription",
                  label: "Item Description",
                },
              ],
            },
            {
              screenField: "Code",
              dataField: "TaxCode",
              allowEditing: false,
              label: "Tax",
              width: ColumnWidth.TaxCode.width,
              maxWidth: ColumnWidth.TaxCode.minWidth,
            },
            {
              screenField: "SalesUM",
              allowEditing: false,
              maxWidth: ColumnWidth.UnitOfMeasure.minWidth,
            },
            {
              screenField: "SalesUMInvoicedQty",
              gridDataField: "SalesUMOrderQty",
              allowEditing: false,
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMInvoicedQty",
              gridDataField: "OutstandingQty",
              allowEditing: false,
              gridLabel: "Outstanding Qty",
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMCreditQty",
              gridDataField: "ToCredit",
              type: "EditableDecimal",
              allowUpdate: true,
              allowEditing: true,
              showEditorAlways: true,
              gridLabel: "Credit Qty",
              makeReadOnly: (data) => {
                if (
                  data.data.IsBatchProduct !== "No" ||
                  data.data.CheckInclude === false ||
                  this.baseView.mode == "review"
                )
                  return true;
                else return false;
              },
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMNetFXPrice",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              maxWidth: ColumnWidth.Price4DecimalPoints.minWidth,
              label: "Price (Customer Currency)",
            },
            {
              screenField: "TaxableFXLineTotal",
              allowEditing: false,
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              label: "Ex Total (Customer Currency)",
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              allowEditing: false,
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "IncTaxFXTotal",
              label: "Inc Total (Customer Currency)",
              dataField: "FXLineTotal",
              allowEditing: false,
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "ProductCategory1",
              filterIndex: 0,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "ProductCategory2",
              filterIndex: 1,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "ProductCategory3",
              filterIndex: 2,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "ProductCategory4",
              filterIndex: 3,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "ProductType",
              filterIndex: 4,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "CheckStockWriteOff",
              headerCellTemplate: null,
              label: "Write Off",
              allowEditing: false,
              defaultValue: this.getFactorDefault,
              makeReadOnly: (data) => {
                if (
                  data.column.dataField == "CheckStockWriteOff" &&
                  (data.data.ToCredit == 0 || !data.data.CheckInclude)
                )
                  return true;
                else return this.baseView.mode == "review" ? true : false;
              },
              makeDisabled: (data) => {
                if (
                  data.column.dataField == "CheckStockWriteOff" &&
                  data.data.ItemType != "S"
                )
                  return true;
                else return false;
              },
              valueChangeCallBack: this.checkBoxValueChange,
              width: ColumnWidth.GridCellCheckBox.width,
              maxWidth: ColumnWidth.GridCellCheckBox.minWidth,
            },
            {
              screenField: "Comments",
              dataField: "Comment",
              // visible: this.baseView.mode == "review",
              allowEditing: this.baseView.mode != "review",
              width: ColumnWidth.Comment.width,
              maxWidth: ColumnWidth.Comment.minWidth,
              cellTemplate: "ScrollView",
              cssClass: "grid-text-scroll",
              editCellTemplate: "EditableTextArea",
              showEditorAlways: true,
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "ToCredit",
              listner: (e, lineData) => {
                if (lineData.data.SalesUMQty < 0) {
                  let val = +Math.abs(e.value);
                  lineData.data.ToCredit = val;
                  if (
                    val >
                    +Math.abs(
                      lineData.data.SalesUMQty +
                        lineData.data.SalesUMCreditedQty,
                    )
                  ) {
                    alert(
                      "The credit quantity cannot be greater than the outstanding quantity available to credit. Please update the Credit Qty",
                      "Validation Errors",
                    );
                    lineData.data.ToCredit = e.previousValue;
                    return;
                  }
                } else {
                  let val = -Math.abs(e.value);
                  lineData.data.ToCredit = val;
                  if (
                    val <
                    -Math.abs(
                      lineData.data.SalesUMQty -
                        lineData.data.SalesUMCreditedQty,
                    )
                  ) {
                    alert(
                      "The credit quantity cannot be greater than the outstanding quantity available to credit. Please update the Credit Qty",
                      "Validation Errors",
                    );
                    lineData.data.ToCredit = e.previousValue;
                    return;
                  }
                }
                if (e.previousValue != 0 && e.value == 0) {
                  lineData.data.CheckStockWriteOff = false;
                  lineData.data.CheckInclude = false;
                }

                if (e.previousValue == 0 && e.value != 0) {
                  lineData.data.CheckInclude = true;
                }

                this.setStockPrices(lineData.data);
                this.setLineTotals(lineData.data);
              },
            },
            {
              dataField: "ToCreditQty",
              listner: (
                e,
                lineData,
                localDs,
                grid,
                lineParent,
                batchGrid,
                refInstance,
              ) => {
                //        e,
                // lineData,
                // grid.getDataSource().items(),
                // grid,
                // lineParent,
                // batchGrid
                if (lineData.data.SalesUMBatchQty < 0) {
                  let val = +Math.abs(e.value);
                  lineData.data.ToCreditQty = val;
                  if (
                    val >
                    +Math.abs(
                      lineData.data.SalesUMBatchQty +
                        lineData.data.SalesUMCreditedQty,
                    )
                  ) {
                    alert(
                      "The credit quantity cannot be greater than the outstanding quantity available to credit. Please update the Credit Qty",
                      "Validation Errors",
                    );
                    lineData.data.ToCreditQty = e.previousValue;
                    e.component.beginUpdate();
                    e.component.option("value", e.previousValue);
                    e.component.endUpdate();
                    grid.refresh();
                    return;
                  }
                } else {
                  let val = -Math.abs(e.value);
                  lineData.data.ToCreditQty = val;
                  lineData.component.cellValue(
                    lineData.rowIndex,
                    "ToCreditQty",
                    val,
                  );
                  batchGrid.refresh(true);

                  if (
                    val <
                    -Math.abs(
                      lineData.data.SalesUMBatchQty -
                        lineData.data.SalesUMCreditedQty,
                    )
                  ) {
                    alert(
                      "The credit quantity cannot be greater than the outstanding quantity available to credit. Please update the Credit Qty",
                      "Validation Errors X",
                    );
                    lineData.data.ToCreditQty = e.previousValue;
                    e.component.beginUpdate();
                    e.component.option("value", e.previousValue);
                    e.component.endUpdate();

                    grid.refresh();
                    return;
                  }
                }
                localDs = grid.getDataSource().items();

                const index = lineParent.rowIndex;
                // if (index > -1) {
                let total = 0;
                lineParent.data.InvoiceProductBatches.forEach((el) => {
                  if (el.BatchNo == lineData.data.BatchNo) {
                    el.ToCreditQty = lineData.data.ToCreditQty;
                    if (e.previousValue != 0 && e.value == 0)
                      el.CheckInclude = false;
                    total += lineData.data.ToCreditQty;
                  } else {
                    total += el.ToCreditQty;
                  }
                });

                lineParent.data.ToCredit = total;

                // const indx = localDs.findIndex(
                //   (x) => x.LineNo === lineData.data.InvoiceLineNo
                // );

                // if (indx != -1) {
                grid.cellValue(index, "ToCredit", total);
                // }
                // }

                if (e.previousValue != 0 && e.value == 0) {
                  if (lineParent.data.ToCredit == 0) {
                    lineParent.data.CheckStockWriteOff = false;
                    lineParent.data.CheckInclude = false;
                    grid.cellValue(index, "CheckStockWriteOff", false);
                    grid.cellValue(index, "CheckInclude", false);
                  }
                  lineData.data.CheckInclude = false;
                  lineData.component.cellValue(
                    lineData.rowIndex,
                    "CheckInclude",
                    false,
                  );
                }

                if (e.previousValue == 0 && e.value != 0) {
                  lineParent.data.CheckInclude = true;
                  grid.cellValue(index, "CheckInclude", true);
                }

                this.setStockPrices(lineParent.data);
                this.setLineTotals(lineParent.data);
                grid.refresh(true);

                this.updateChildGridOnQtyUpdate(
                  index,
                  lineParent,
                  grid,
                  batchGrid,
                  refInstance,
                );
              },
            },
            {
              dataField: "Comment",
              listner: (e, lineData) => {
                lineData.data.Comment = e.value;
              },
            },
            {
              dataField: "CartonCreditQty",
              listner: (
                e,
                lineData,
                gridItems,
                grid,
                lineParent,
                batchGrid,
                refInstance,
              ) => {
                if (+Math.abs(e.value) > lineData.data.CartonQty) {
                  alert(
                    "The credit quantity cannot be greater than the outstanding quantity available to credit. Please update the Credit Qty",
                    "Validation Errors",
                  );
                  lineData.data.CartonCreditQty = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                  grid.refresh(true);
                  return;
                }

                lineData.data.CartonCreditQty = -Math.abs(e.value);
                lineData.data.DespatchCreditWeight =
                  lineData.data.CartonCreditQty * lineParent.data.PackSize;

                var TotalWeight = 0;
                lineParent.data.InvoiceProductBatches.forEach((element) => {
                  TotalWeight = TotalWeight + element.DespatchCreditWeight;
                });

                lineParent.data.ToCredit =
                  TotalWeight / lineParent.data.SalesUMInvoiceConversion;

                const index = lineParent.rowIndex;

                // var rowIndex = batchGrid.getRowIndexByKey(lineData.data);
                // var parentRowIndex = grid.getRowIndexByKey(lineParent.data);
                // if (lineData.data.CartonCreditQty != 0) {
                //   // lineParent.data.CheckInclude = true;
                //   // grid.cellValue(lineParent.rowIndex, "CheckInclude", true);
                //   batchGrid.cellValue(lineData.rowIndex, "CheckInclude", true);
                // }
                if (lineData.data.CartonCreditQty == 0) {
                  lineData.data.CheckInclude = false;
                  batchGrid.cellValue(lineData.rowIndex, "CheckInclude", false);
                }

                if (index > -1) {
                  // gridItems[index].ToCredit =
                  //   TotalWeight / (lineParent.data.SalesUMInvoiceConversion);
                  grid.cellValue(
                    index,
                    "ToCredit",
                    TotalWeight / lineParent.data.SalesUMInvoiceConversion,
                  );
                }
                // setTimeout(() => {
                // this.$refs["invoice-credit"].$refs[
                //   "transactionGrid"
                // ].updateChildGridHeaderCheckBox();
                // grid.refresh(true);
                // }, 25);

                grid.saveEditData();
                this.updateChildGridOnQtyUpdate(
                  index,
                  lineParent,
                  grid,
                  batchGrid,
                  refInstance,
                );
              },
            },
          ],
          childGrid: [
            {
              columns: [
                {
                  screenField: "DateIn",
                  filterIndex: 0,
                  sortOrder: "asc",
                  sortIndex: 0,
                },
                {
                  screenField: "CustomerTransactionType",
                  filterIndex: 1,
                },
                {
                  screenField: "CustomerTransactionNumber",
                },
                {
                  screenField: "SalesOrder",
                  filterIndex: 2,
                },
              ],
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              dataField: "ToCredit",
              location: "left",
              label: "Item Count",
              value: 0,
              format: "Decimal-16-0",
            },
            {
              screenField: "FXTotal",
              dataField: "FXCommissionTotal",
              location: "left",
              label: "Commission Payable (Customer Currency)",
              visible: this.baseView.mode == "review",
              customCalc: (headerData) => {
                var total = 0;
                if (this.baseView.mode == "review") {
                  total = headerData.FXCommissionTotal.roundNumber(2);
                }
                return total;
              },
            },
            {
              dataField: "TaxableFXLineTotal",
              location: "right",
              label: `Sub Total (${
                getDefaultCustomerSettings().CustomerCurrency
              })`,
              value: 0,
              format: "Decimal-16-2C",
            },
            {
              dataField: "TaxFXLineTotal",
              location: "right",
              label: `Tax (${getDefaultCustomerSettings().CustomerCurrency})`,
              value: 0,
              format: "Decimal-16-2C",
            },
            {
              dataField: "FXLineTotal",
              location: "right",
              label: `Total (${getDefaultCustomerSettings().CustomerCurrency})`,
              value: 0,
              format: "Decimal-16-2C",
            },
          ],
        },
      };
      return screenJson;
    },
    getFactorDefault() {
      return this.CheckStockWriteOff;
    },
    checkIncludeValue() {
      return this.BulkInclude;
    },
    getChildColumns() {
      if (this.almondcoQCData) {
        return [
          {
            visible: this.baseView.mode !== "review",
            screenField: "CheckInclude",
            label: "",
            allowEditing: false,
            defaultValue: true,
            valueChangeCallBack: this.childGridCheckBoxValueChange,
            allowHiding: false,
            showInColumnChooser: false,
            width: 40,
          },
          {
            screenField: "Date",
            gridDataField: "DespatchDate",
            label: "Despatch Date",
            filterIndex: 0,
            width: 100,
            // editable: true,
            // cellTemplate: "Date",
            minWidth: 100,
            // makeReadOnly: (data) => {
            //   if (data.data.isNew) return false;
            //   else return true;
            // },
          },
          {
            screenField: "Date",
            gridDataField: "PackedOnDate",
            label: "Packed On Date",
            // editable: true,
            // cellTemplate: "Date",
            minWidth: 100,
            width: 100,
            // makeReadOnly: (data) => {
            //   if (data.data.isNew) return false;
            //   else return true;
            // },
            // editorOptions: {
            //   max: new Date(),
            // },
          },
          {
            screenField: "WorkOrder",
            gridDataField: "WorkOrder",
            // cellTemplate: "SelectField",
            // allowUpdate: true,
            // makeReadOnly: (data) => {
            //   if (data.data.isNew) return false;
            //   else return true;
            // },
            calculateCellValue: (data) => {
              return data.WorkOrder;
            },
            cellTemplate: undefined,
            itemTemplate: undefined,
            cellTemplateRecord: undefined,
            // dropDownOptions: {
            //   width: 300,
            // },
            // validationRules: [
            //   {
            //     type: "required",
            //     message: "Work Order is required",
            //   },
            // ],
            // dataType: "string",
          },
          {
            screenField: "SalesOrderLine",
            gridDataField: "LotNo",
            label: "Lot No",
            minWidth: 80,
            width: 80,

            // type: "EditableDecimal",
            // format: "Decimal-16-0",
            // showEditorAlways: true,
            allowSearch: false,
            // allowSorting: false,
            allowFiltering: false,
            // minmax: { max: 999999.0 },
            // makeReadOnly: (data) => {
            //   if (data.data.isNew) return false;
            //   else return true;
            // },
            // allowUpdate: true,
          },
          {
            screenField: "SalesOrderLine",
            gridDataField: "PalletNo",
            label: "Pallet No",
            minWidth: 80,
            width: 80,

            // type: "EditableDecimal",
            // format: "Decimal-16-0",
            // showEditorAlways: true,
            allowSearch: false,
            // allowSorting: false,
            allowFiltering: false,
            // minmax: { max: 999999.0 },
            // makeReadOnly: (data) => {
            //   if (data.data.isNew) return false;
            //   else return true;
            // },
            // allowUpdate: true,
          },
          {
            screenField: "ReceivedQty",
            label: `Carton \r\nInvoiced Qty`,
            gridDataField: "CartonQty",
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            allowSearch: false,
            allowFiltering: false,
            headerCellTemplate: function (header, info) {
              header.innerHTML = info.column.caption.replace(/\r\n/g, "<br/>");
            },
          },
          {
            screenField: "ReceivedQty",
            label: `Carton \r\nOutstanding Qty`,
            gridDataField: "CartonOutstandingQty",
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            allowSearch: false,
            allowFiltering: false,
            headerCellTemplate: function (header, info) {
              header.innerHTML = info.column.caption.replace(/\r\n/g, "<br/>");
            },
          },
          {
            screenField: "SalesUMCreditQty",
            gridDataField: "CartonCreditQty",
            label: "Carton \r\nCredit Qty",
            type: "EditableDecimal",
            allowUpdate: true,
            allowEditing: true,
            showEditorAlways: true,
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            makeReadOnly: (data) => {
              if (data.data.CheckInclude != true) return true;
              else return false;
            },
            headerCellTemplate: function (header, info) {
              header.innerHTML = info.column.caption.replace(/\r\n/g, "<br/>");
            },
          },
          {
            screenField: "ReceivedQty",
            gridDataField: "TotalWeight",
            label: "Despatch \r\nInvoiced Weight",
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            headerCellTemplate: function (header, info) {
              header.innerHTML = info.column.caption.replace(/\r\n/g, "<br/>");
            },
          },
          {
            screenField: "SalesUMCreditQty",
            dataField: "DespatchCreditWeight",
            label: "Despatch \r\nCredit Weight",
            type: "Decimal",
            width: ColumnWidth.Quantity.width,
            minWidth: ColumnWidth.Quantity.minWidth,
            headerCellTemplate: function (header, info) {
              header.innerHTML = info.column.caption.replace(/\r\n/g, "<br/>");
            },
          },
        ];
      } else {
        return [
          {
            visible: this.baseView.mode !== "review",
            screenField: "CheckInclude",
            label: "",
            allowEditing: false,
            defaultValue: true,
            valueChangeCallBack: this.childGridCheckBoxValueChange,
            allowHiding: false,
            showInColumnChooser: false,
            width: 40,
          },
          {
            screenField: "Batch",
            gridDataField: "BatchNo",
            allowEditing: false,
            width: 100,
          },

          {
            screenField: "Supplier",
            allowEditing: false,
            gridDataField: "SupplierCode",
            cellTemplateRecord: {
              primary: [
                {
                  dataField: "SupplierName",
                },
              ],
              secondary: [
                {
                  dataField: "SupplierCode",
                },
              ],
            },
          },
          {
            screenField: "UseByDate",
            allowEditing: false,
            minWidth: 100,
            width: 100,
          },
          {
            screenField: "SalesUMInvoicedQty",
            gridDataField: "SalesUMBatchQty",
            allowEditing: false,
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          },
          {
            screenField: "SalesUMInvoicedQty",
            gridDataField: "OutstandingBatchQty",
            allowEditing: false,
            gridLabel: "Outstanding Qty",
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          },
          {
            screenField: "SalesUMCreditQty",
            gridDataField: "ToCreditQty",
            label: "Credit Qty",
            type: "EditableDecimal",
            showEditorAlways: true,
            gridLabel: this.baseView.mode == "review" ? "Credited" : undefined,
            format: "Decimal-16-4",
            width: ColumnWidth.Quantity4DecimalPoints.width,
            maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            makeReadOnly: (data) => {
              if (data.data.CheckInclude != true) return true;
              else return false;
            },
          },
        ];
      }
    },
    getSelectOptions() {
      var select = [
        "CustomerDeliveryAddressLineNo",
        "DateIn",
        "DateDue",
        "OrderNo",
        "DeliveryAddressCompanyName",
        "BranchDescription",
        "DivisionDescription",
        "SalesOrderTypeDescription",
        "SalesRepresentativeFullName",
        "ExchangeRate",
        "CurrencyCode",
        "Code",
        "SalesOrderCode",
        "DeliveryNoteCode",
        "DateCreated",
        "CreatedBy",
        "DateChanged",
        "Status",
        "CustomerCode",
        "CustomerName",
        "SalesOrderTypeCode",
        "UserComment1",
        "UserComment2",
        "UserComment3",
        "UserComment4",
        "UserComment5",
        "UserComment6",
        "UserComment7",
        "UserComment8",
        "UserComment9",
        "UserComment10",
        "UserComment11",
        "UserComment12",
        "UserComment13",
        "UserComment14",
        "UserComment15",
        "UserComment16",
        "UserComment17",
        "UserComment18",
        "UserComment19",
        "UserComment20",
        "DeliveryAddressCompanyName",
        "DeliveryAddressCountry",
        "DeliveryAddressPostcode",
        "DeliveryAddressState",
        "DeliveryAddressStreetLine1",
        "DeliveryAddressStreetLine2",
        "DeliveryAddressSuburb",
        "FXCommissionTotal",
        "DateChanged",
      ];
      if (this.headerEndpoint == "Invoice")
        select.push("AgentName", "AgentCommissionPcnt", "FXCommissionTotal");
      else select.push("OriginalInvoiceCode");

      return select;
    },
    exchangeRateEditable() {
      return (
        this.baseView.mode != "review" && this.BaseCurrency != this.CurrencyCode
      );
    },
  },
  methods: {
    onFormContentReady(e) {
      setTimeout(() => {
        if (!this.headerFormInstance) this.headerFormInstance = e.component;
        if (
          this.headerFormInstance &&
          this.headerFormInstance.getEditor("DateIn")
        )
          this.headerFormInstance.getEditor("DateIn").instance().focus();
      }, 500);
    },
    moveOnKeyDown(e) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        var dataGrid =
          this.$refs["invoice-credit"].$refs["transactionGrid"].$refs[
            "gc-dat-gridtransaction-grid"
          ].instance;
        if (dataGrid.getDataSource().items().length > 0) {
          e.event.preventDefault();
          let cellElement = dataGrid.getCellElement(0, "CheckInclude");
          dataGrid.focus(cellElement);
          dataGrid.editCell(0, "CheckInclude");
        }
      }
    },
    onExchangeValueChanged(e) {
      if (!e.event) return;
      if (e.value <= 0) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: "Exchange rate should be greater than 0.0000",
        });
        e.component.instance().option("value", e.previousValue);
      }
    },
    async updateChildGridOnQtyUpdate(
      index,
      lineParent,
      grid,
      batchGrid,
      refInstance,
    ) {
      setTimeout(() => {
        batchGrid.refresh(true).then(() => {
          var count = 0;
          var gridItems = lineParent.data.InvoiceProductBatches;
          gridItems.forEach((el) => {
            if (el.CheckInclude) count++;
          });
          var checkBox = refInstance.element();
          var getInstance = CheckBox.getInstance(checkBox);

          if (!getInstance) getInstance = refInstance;

          // setTimeout(() => {
          if (count > 0 && count != gridItems.length) {
            getInstance.option("value", undefined);
            grid.cellValue(index, "CheckInclude", true);
          } else if (count == 0) {
            getInstance.option("value", false);
            grid.cellValue(index, "CheckInclude", false);
          } else if (count == gridItems.length) {
            getInstance.option("value", true);
            grid.cellValue(index, "CheckInclude", true);
          }

          // }, 5);

          grid
            .getDataSource()
            .items()
            .forEach((element) => {
              this.setStockPrices(element);
              this.setLineTotals(element);

              grid.saveEditData();
            });

          grid.refresh(true).then(() => {
            batchGrid.refresh(true);
          });
        });
      }, 100);
    },
    async initialized() {
      await DefaultCompanyBranchDivisionService.getDefault().then(
        async ({ data }) => {
          // this.dataModel.CompanyCode = data.value[0].CompanyCode;
          await CompanyService.getByCompanyCode(data.value[0].CompanyCode, {
            select: ["Code", "CurrencyCode"],
          }).then((res) => {
            if (res.data.value.length > 0) {
              this.CompanyCurrency = res.data.value[0].CurrencyCode;
            }
          });
        },
      );
      if (this.baseView.query && this.baseView.query.from)
        this.backButtonRoute = this.baseView.query.from;

      this.loaded = false;

      if (!this.headerEndpoint)
        await TransactionService.getByCode(
          "InvoiceList",
          "Invoice eq " + this.baseView.id,
          ["Invoice", "InvoiceType"],
        ).then((res) => {
          if (
            res.data.value.length > 0 &&
            res.data.value[0].InvoiceType != "Invoice"
          )
            this.headerEndpoint = "InvoiceCredit";
          else this.headerEndpoint = "Invoice";
          this.loaded = true;
        });
      else this.loaded = true;
    },
    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.ToCredit,
        record.SalesUMInvoiceConversion,
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMInvoiceConversion,
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMInvoiceConversion,
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMInvoiceConversion,
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMInvoiceConversion,
      );
    },
    setLineTotals(record) {
      // FX Totals

      const multiplyAndRound = (a, b) => {
        const product = a * b;
        const epsilon = Number.EPSILON; // tiny shift

        const rounded = Math.round((Math.abs(product) + epsilon) * 100) / 100;
        return (Math.sign(product) * rounded).toFixed(2);
      };

      const round2 = (val) => {
        const negative = val < 0;
        const abs = Math.abs(val);

        const str = abs.toFixed(4);
        const [int, dec] = str.split(".");

        const d1 = parseInt(dec[0]);
        const d2 = parseInt(dec[1]);
        const d3 = parseInt(dec[2]);

        let cents = d1 * 10 + d2;
        if (d3 >= 5) cents += 1;

        const result = (parseInt(int) + cents / 100).toFixed(2);
        return negative ? (-result).toFixed(2) : result;
      };

      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.ToCredit,
      );

      record.NetFXLineTotal = multiplyAndRound(
        round2(record.SalesUMNetFXPrice),
        round2(record.ToCredit),
      );

      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt,
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
      );

      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt,
      );

      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal,
      );

      var exchangeRate =
        this.$refs["invoice-credit"].getTransactionData().ExchangeRate;

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        exchangeRate,
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        exchangeRate,
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        exchangeRate,
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        exchangeRate,
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        exchangeRate,
      );
      record.LineTotal = calculateLineTotal(record.FXLineTotal, exchangeRate);
    },
    childGridCheckBoxValueChange(
      fieldData,
      recordData,
      refInstance,
      parentGridInstance,
    ) {
      var parentGridItems = parentGridInstance.getDataSource().items();
      var batchGrid = recordData.component.instance();

      var gridItems = recordData.component.getDataSource().items();
      var checkBox = refInstance.element();
      var getInstance = CheckBox.getInstance(checkBox);
      let count = 0;
      let totalDespatchCreditWeight = 0;
      let parentRowIndex = -1;
      let totalCredit = 0;
      var batchRowIndex = batchGrid.getRowIndexByKey(recordData.data);

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          gridItems.forEach((element, i) => {
            var parentLine = parentGridItems.find(
              (x) => x.LineNo == element.InvoiceLineNo,
            );

            if (!parentLine) return;
            parentRowIndex = parentGridInstance.getRowIndexByKey(parentLine);

            if (element.DespatchData) {
              if (fieldData.value) count = count + 1;

              element[recordData.column.dataField] = fieldData.value;
              recordData.component.beginUpdate();
              recordData.component.cellValue(
                i,
                recordData.column.dataField,
                fieldData.value,
              );

              if (
                recordData.column.dataField == "CheckInclude" &&
                !fieldData.value
              ) {
                element.DespatchCreditWeight = 0;
                recordData.component.cellValue(i, "CartonCreditQty", 0);
              } else {
                recordData.component.cellValue(
                  i,
                  "CartonCreditQty",
                  -Math.abs(element.CartonOutstandingQty),
                );
                element.DespatchCreditWeight =
                  -Math.abs(element.CartonOutstandingQty) * parentLine.PackSize;
              }
              totalDespatchCreditWeight =
                totalDespatchCreditWeight + element.DespatchCreditWeight;
              parentLine.ToCredit = -Math.abs(
                totalDespatchCreditWeight /
                  (parentLine.StockUMQty / parentLine.SalesUMQty),
              );
              recordData.component.endUpdate();
            } else {
              if (fieldData.value) {
                count = count + 1;
                element.ToCreditQty = -Math.abs(element.OutstandingBatchQty);
                element.CheckInclude = true;
                recordData.component.cellValue(
                  i,
                  "ToCreditQty",
                  -Math.abs(element.OutstandingBatchQty),
                );
                recordData.component.cellValue(i, "CheckInclude", true);
              } else {
                element.ToCreditQty = 0;
                element.CheckInclude = false;
                recordData.component.cellValue(i, "ToCreditQty", 0);
                recordData.component.cellValue(i, "CheckInclude", false);
              }
              totalCredit = totalCredit + element.ToCreditQty;
              parentLine.ToCredit = -Math.abs(totalCredit);
            }
            parentGridInstance.cellValue(
              parentRowIndex,
              "ToCredit",
              parentLine.ToCredit,
            );
          });
          recordData.component.instance().refresh(true);
        }
      } else if (recordData.rowType == "data") {
        var parentLine = parentGridItems.find(
          (x) => x.LineNo == recordData.data.InvoiceLineNo,
        );
        parentRowIndex = parentGridInstance.getRowIndexByKey(parentLine);
        gridItems.forEach((element, i) => {
          if (element.DespatchData) {
            // recordData.component.beginUpdate();

            if (!parentLine) return;

            if (element.Code == recordData.data.Code) {
              batchGrid.cellValue(i, "CheckInclude", fieldData.value);

              if (!fieldData.value) {
                element.CheckInclude = false;
                element.CartonCreditQty = 0;
                batchGrid.cellValue(batchRowIndex, "CartonCreditQty", 0);
                batchGrid.cellValue(batchRowIndex, "DespatchCreditWeight", 0);
                batchGrid.cellValue(batchRowIndex, "CheckInclude", false);
                element.DespatchCreditWeight = 0;
              } else {
                count = count + 1;
                element.CheckInclude = true;
                element.CartonCreditQty = -Math.abs(
                  element.CartonOutstandingQty,
                );
                batchGrid.cellValue(
                  batchRowIndex,
                  "CartonCreditQty",
                  -Math.abs(element.CartonOutstandingQty),
                );
                element.DespatchCreditWeight =
                  -Math.abs(element.CartonOutstandingQty) * parentLine.PackSize;

                batchGrid.cellValue(
                  batchRowIndex,
                  "CartonCreditQty",
                  element.CartonCreditQty,
                );
                batchGrid.cellValue(
                  batchRowIndex,
                  "DespatchCreditWeight",
                  element.DespatchCreditWeight,
                );
                batchGrid.cellValue(batchRowIndex, "CheckInclude", true);
              }
              totalDespatchCreditWeight =
                totalDespatchCreditWeight + element.DespatchCreditWeight;
            } else {
              totalDespatchCreditWeight =
                totalDespatchCreditWeight + element.DespatchCreditWeight;
              if (element.CheckInclude) {
                count = count + 1;
              }
            }
            totalCredit = -Math.abs(
              totalDespatchCreditWeight /
                (parentLine.StockUMQty / parentLine.SalesUMQty),
            );
            // totalCredit =
            //   totalCredit +
            //   totalDespatchCreditWeight / ( parentLine.StockUMQty / parentLine.SalesUMQty);
          } else {
            recordData.component.beginUpdate();
            var lineItem = recordData.data;
            if (
              element.BatchNo == lineItem.BatchNo &&
              element.ItemCode == lineItem.ItemCode
            ) {
              if (!fieldData.value) {
                element.ToCreditQty = 0;
                element.CheckInclude = false;
                recordData.component.cellValue(
                  recordData.rowIndex,
                  "ToCreditQty",
                  0,
                );
                recordData.component.cellValue(
                  recordData.rowIndex,
                  "CheckInclude",
                  false,
                );
              } else {
                count = count + 1;
                element.ToCreditQty = -Math.abs(lineItem.OutstandingBatchQty);
                element.CheckInclude = true;
                recordData.component.cellValue(
                  recordData.rowIndex,
                  "ToCreditQty",
                  -Math.abs(lineItem.OutstandingBatchQty),
                );
                recordData.component.cellValue(
                  recordData.rowIndex,
                  "CheckInclude",
                  true,
                );
              }
            } else {
              if (element.CheckInclude) {
                count = count + 1;
              }
            }
            totalCredit = totalCredit + element.ToCreditQty;
            recordData.component.endUpdate();
            // recordData.component.instance().refresh(true);
          }
          parentLine.ToCredit = -Math.abs(totalCredit);
        });

        parentGridInstance.cellValue(
          parentRowIndex,
          "ToCredit",
          parentLine.ToCredit,
        );
      }

      batchGrid.saveEditData();

      parentGridInstance.refresh(true).then(() => {
        batchGrid.refresh().then(() => {
          gridItems = recordData.component.getDataSource().items();

          parentGridItems.forEach((element) => {
            this.setStockPrices(element);
            this.setLineTotals(element);
          });

          setTimeout(() => {
            if (count > 0 && count != gridItems.length) {
              getInstance.option("value", undefined);
              parentGridInstance.cellValue(
                parentRowIndex,
                "CheckInclude",
                true,
              );
            } else if (count == 0) {
              getInstance.option("value", false);
              parentGridInstance.cellValue(
                parentRowIndex,
                "CheckInclude",
                false,
              );
            } else if (count == gridItems.length) {
              getInstance.option("value", true);
              parentGridInstance.cellValue(
                parentRowIndex,
                "CheckInclude",
                true,
              );
            }

            // recordData.component.instance().refresh(true);
            // parentGridInstance.refresh(true);
            parentGridInstance.saveEditData().then(() => {
              this.changeInclude();
            });
          }, 5);
        });
      });
    },
    checkBoxValueChange(fieldData, recordData, refInstance) {
      if (!fieldData.event) return;
      var gridItems = recordData.component.getDataSource().items();

      var checkBox = refInstance ? refInstance.element() : false;
      var getInstance = checkBox ? CheckBox.getInstance(checkBox) : false;

      if (recordData.rowType == "header") {
        gridItems.forEach((element) => {
          if (element.IsBatchProduct == "Yes")
            recordData.component.collapseRow(
              recordData.component.keyOf(element),
            );
        });
        //  this.$refs["invoice-credit"].$refs["transactionGrid"].gridRepaint();

        // return;

        if (fieldData.value == undefined) return;
        else {
          let count = 0;
          gridItems.forEach((element, i) => {
            if (recordData.column.dataField == "CheckStockWriteOff")
              if (!element.CheckInclude) return;
            if (fieldData.value) count = count + 1;

            element[recordData.column.dataField] = fieldData.value;
            // recordData.component.beginUpdate();
            recordData.component.cellValue(
              i,
              recordData.column.dataField,
              fieldData.value,
            );

            if (
              recordData.column.dataField == "CheckInclude" &&
              !fieldData.value
            ) {
              // element["ToCredit"] = 0;
              element["CheckStockWriteOff"] = fieldData.value;
              recordData.component.cellValue(
                i,
                "CheckStockWriteOff",
                fieldData.value,
              );
              recordData.component.cellValue(i, "ToCredit", 0);
              this.updateCheckStockWriteOffBulk();
              if (element["IsBatchProduct"] != "No") {
                element.InvoiceProductBatches.forEach((item) => {
                  if (item.DespatchData) {
                    item.CheckInclude = false;
                    item.CartonCreditQty = 0;
                    item.DespatchCreditWeight = 0;
                  } else item.ToCreditQty = 0;
                });
              }
            } else {
              recordData.component.cellValue(
                i,
                "ToCredit",
                -Math.abs(element.SalesUMQty - element.SalesUMCreditedQty),
              );

              if (element["IsBatchProduct"] != "No") {
                element.InvoiceProductBatches.forEach((item) => {
                  if (item.DespatchData) {
                    item.CheckInclude = true;
                    item.CartonCreditQty = -Math.abs(item.CartonOutstandingQty);
                    item.DespatchCreditWeight =
                      -Math.abs(item.CartonOutstandingQty) * element.PackSize;
                  } // else item.ToCreditQty = 0;
                });
              }
            }
            // recordData.component.endUpdate();
          });

          if (getInstance) {
            if (count > 0 && count != gridItems.length) {
              getInstance.option("value", undefined);
            } else if (count == 0) getInstance.option("value", false);
            else if (count == gridItems.length)
              getInstance.option("value", true);
          }

          setTimeout(() => {
            // recordData.component.instance().refresh(true);
            recordData.component.instance().saveEditData();
          }, 25);
        }
        return;
      }
      if (recordData.rowType == "data") {
        let count = 0;
        gridItems.forEach((element) => {
          if (element.LineNo == recordData.data.LineNo) {
            var rowIndex = recordData.component.getRowIndexByKey(element);
            element[recordData.column.dataField] = fieldData.value;
            if (fieldData.value) {
              count = count + 1;
            }

            if (recordData.column.dataField == "CheckInclude")
              if (fieldData.value == false) {
                element["ToCredit"] = 0;
                // recordData.component.beginUpdate();
                recordData.component.cellValue(
                  rowIndex,
                  "CheckStockWriteOff",
                  false,
                );
                recordData.component.cellValue(rowIndex, "ToCredit", 0);
                recordData.component.cellValue(rowIndex, "CheckInclude", false);
                // recordData.component.endUpdate();
                element.CheckStockWriteOff = false;
                element.CheckInclude = false;

                this.updateCheckStockWriteOffBulk();

                if (element["IsBatchProduct"] != "No") {
                  element.InvoiceProductBatches.forEach((item) => {
                    if (item.DespatchData) {
                      item.CheckInclude = false;
                      item.CartonCreditQty = 0;
                      item.DespatchCreditWeight = 0;
                    } else {
                      item.ToCreditQty = 0;
                      item.CheckInclude = false;
                    }
                  });
                }
                // this.$refs["invoice-credit"].$refs["transactionGrid"].gridRepaint();

                // childGetInstance.option("value", false);
              } else {
                recordData.component.cellValue(rowIndex, "CheckInclude", true);
                element.CheckInclude = true;
                if (element["IsBatchProduct"] != "No") {
                  element.InvoiceProductBatches.forEach((item) => {
                    if (item.DespatchData) {
                      item.CheckInclude = true;
                      item.CartonCreditQty = -Math.abs(
                        item.CartonOutstandingQty,
                      );
                      item.DespatchCreditWeight =
                        -Math.abs(item.CartonOutstandingQty) * element.PackSize;
                    } else {
                      item.ToCreditQty = -Math.abs(item.OutstandingBatchQty);
                      item.CheckInclude = true;
                    }
                  });
                }

                let toCredit =
                  recordData.data.SalesUMQty -
                  recordData.data.SalesUMCreditedQty;
                toCredit = -Math.abs(toCredit);

                element["ToCredit"] = toCredit;
                // recordData.component.beginUpdate();
                recordData.component.cellValue(rowIndex, "ToCredit", toCredit);
                // recordData.component.endUpdate();
                // childGetInstance.option("value", true);
              }
          } else if (element[recordData.column.dataField] == true) {
            count = count + 1;
          }
        });

        if (getInstance) {
          if (count > 0 && count != gridItems.length) {
            getInstance.option("value", undefined);
          } else if (count == 0) getInstance.option("value", false);
          else if (count == gridItems.length) getInstance.option("value", true);
        }
      }

      gridItems.forEach((element) => {
        this.setStockPrices(element);
        this.setLineTotals(element);
      });

      recordData.component.instance().saveEditData();
      setTimeout(() => {
        recordData.component.instance().refresh();
      }, 200);
    },

    async PostProcessHeaderData(data) {
      // set the default DateIn to today when Invoice Credit is loaded
      if (data) {
        // - #31319: UI : Invoice Review screen - PDF preview icon and generate PDF of the transaction report
        // - To match ScreenNameToLayout parameter.dataField
        data["Invoice"] = data.Code;
        // data["Status"] = data.CreditStatus;
        data.Status = "Credit";
        if (this.baseView.mode != "review") {
          logDev("data.DateIn", data.DateIn);
          this.DateIn.min = data.DateIn;
          if (data.DateIn < new Date().toSaveDate()) {
            data.DateIn = new Date().toSaveDate();
          }
        }

        data.ResupplyOrder = getFactorByCode(665).Factorc == "Y" ? true : false;

        if (!data.SalesOrderCode) {
          this.disabledReSupply = true;
          data.ResupplyOrder = false;
        }
        this.CurrencyCode = data.CurrencyCode;

        if (saveModel.OriginalInvoiceCode) {
          data.OriginalInvoiceCode = saveModel.OriginalInvoiceCode;
        }
      }
    },
    PostProcess(data) {
      var items = [];

      data.forEach((element) => {
        if (element.SalesUMQty != element.SalesUMCreditedQty) {
          if (this.baseView.mode == "review")
            element.ToCredit = element.SalesUMQty;
          else if (element.SalesUMQty >= 0)
            element.ToCredit = -Math.abs(
              element.SalesUMQty - element.SalesUMCreditedQty,
            );
          else if (element.SalesUMQty == element.SalesUMCreditedQty) return;
          else
            element.ToCredit = Math.abs(
              element.SalesUMQty - element.SalesUMCreditedQty,
            );

          element.SalesUMInvoiceConversion =
            element.StockUMQty / element.SalesUMQty;

          if (this.baseView.mode != "review") {
            this.setStockPrices(element);
            this.setLineTotals(element);
          }

          if (element.ToCredit < 0) element.CheckInclude = true;
          else element.CheckInclude = false;

          if (element.WriteOff == "Y" && this.baseView.mode != "create") {
            element.CheckStockWriteOff = true;
          } else if (this.baseView.mode == "create" && this.getFactorDefault) {
            element.CheckStockWriteOff = true;
          } else {
            element.CheckStockWriteOff = false;
          }

          if (this.baseView.mode == "review") element.CheckInclude = true;
          if (element["IsBatchProduct"] != "No") {
            InvoiceCreditService.getProductBatches(
              `InvoiceCode eq ${element["InvoiceCode"]} and InvoiceLineNo eq ${element["LineNo"]}`,
              {
                select: [
                  "BatchNo",
                  "ItemCode",
                  "StockUMQty",
                  "SalesUMQty",
                  "SupplierCode",
                  "SupplierName",
                  "InvoiceLineNo",
                  "SalesUMCreditedQty",
                  "UseByDate",
                  "InvoiceCode",
                  "BranchCode",
                ],
              },
            ).then((response) => {
              element["InvoiceProductBatches"] = response.data.value
                .map((el) => {
                  let batchline = {
                    BatchNo: el.BatchNo,
                    ItemCode: el.ItemCode,
                    ToCreditQty: undefined,
                    StockUMBatchQty: el.StockUMQty,
                    SalesUMBatchQty: el.SalesUMQty,
                    SalesUMInvoiceConversion: element.SalesUMInvoiceConversion,
                    SupplierCode: el.SupplierCode,
                    SupplierName: el.SupplierName,
                    InvoiceLineNo: el.InvoiceLineNo,
                    SalesUMCreditedQty: el.SalesUMCreditedQty,
                    OutstandingBatchQty: el.SalesUMQty - el.SalesUMCreditedQty,
                    CheckInclude: true,
                  };

                  if (this.baseView.mode == "review")
                    batchline.ToCreditQty = el.SalesUMQty;
                  else if (el.SalesUMQty >= 0)
                    batchline.ToCreditQty = -Math.abs(
                      el.SalesUMQty - el.SalesUMCreditedQty,
                    );
                  else if (el.SalesUMQty < 0)
                    batchline.ToCreditQty = Math.abs(
                      el.SalesUMQty - el.SalesUMCreditedQty,
                    );

                  // original invoice batch data
                  if (this.baseView.mode == "review") {
                    var OriginalInvoiceCode =
                      this.$refs["invoice-credit"].getTransactionData()
                        .OriginalInvoiceCode;
                    InvoiceCreditService.getProductBatches(
                      `InvoiceCode eq ${OriginalInvoiceCode} and ItemCode eq '${el.ItemCode}' and BatchNo eq '${el.BatchNo}' and BranchCode eq '${el.BranchCode}' and SupplierCode eq '${el.SupplierCode}'`,
                      {
                        select: [
                          "SalesUMQty",
                          "InvoiceCode",
                          "ItemCode",
                          "BatchNo",
                          "BranchCode",
                          "SupplierCode",
                        ],
                      },
                    ).then((res) => {
                      batchline.SalesUMBatchQty = res.data.value[0].SalesUMQty;
                    });
                  }

                  if (el.SalesUMQty != el.SalesUMCreditedQty) return batchline;
                })
                .filter(Boolean);
            });
          }

          if (this.almondcoQCData) {
            element["InvoiceProductBatches"] = this.almondcoQCData.filter(
              (x) => x.InvoiceLineNo == element.LineNo,
            );

            if (element["InvoiceProductBatches"].length > 0)
              element.IsBatchProduct = "Yes";
          }

          element.OutstandingQty =
            element.SalesUMQty - element.SalesUMCreditedQty;

          items.push(element);
        }
      });
      return items;
    },
    async saveData(headerData, getDetailLines) {
      if (getDetailLines.length == 0)
        getDetailLines = this.getDataContext("gcDataGrid");
      var detailLines = getDetailLines.filter((x) => x.CheckInclude);
      for (let key in saveModel) {
        if (key == "DateIn") {
          saveModel.DateIn = headerData.DateIn
            ? new Date(headerData.DateIn).toSaveDate()
            : new Date().toSaveDate();
          continue;
        }
        if (key == "TransactionFlag") {
          saveModel.TransactionFlag = 12;
          continue;
        }
        if (key == "OriginalInvoiceCode") {
          saveModel.OriginalInvoiceCode = headerData.Code;
          continue;
        }

        if (key == "InvoiceCreditDetails") {
          continue;
        }
        saveModel[key] = headerData[key];
        saveModel.CustomerDeliveryAddressLineNo =
          saveModel.CustomerDeliveryAddressLineNo.toString();
      }
      let details = detailLines.map((line) => {
        let saveLine = Object.assign({}, saveModel.InvoiceCreditDetails[0]);
        for (let key in saveLine) {
          if (key == "DiscLineTotal") {
            saveLine.DiscLineTotal = calculateDiscLineTotal(
              line.DiscFXLineTotal,
              headerData.ExchangeRate,
            );
            continue;
          }
          if (key == "TaxLineTotal") {
            saveLine.TaxLineTotal = calculateTaxLineTotal(
              line.TaxFXLineTotal,
              headerData.ExchangeRate,
            );
            continue;
          }
          if (key == "BatchStockTolerance") {
            saveLine.BatchStockTolerance = line.SaleItem.BatchStockTolerance;
            continue;
          }

          if (key == "WriteOff") {
            saveLine.WriteOff = line.CheckStockWriteOff == true ? "Y" : "N";
            continue;
          }
          if (key == "SalesUMQty") {
            saveLine.SalesUMQty = line.ToCredit;
            continue;
          }
          if (key == "OriginalInvoiceLineNo") {
            saveLine.OriginalInvoiceLineNo = line.LineNo;
            continue;
          }

          saveLine[key] = line[key];
          if (saveLine.PriceGroupCode == null) saveLine.PriceGroupCode = 0;

          if (saveLine.PricingMethod == null) saveLine.PricingMethod = "";
        }

        return saveLine;
      });

      if (details.length == 0) {
        this.$notify(
          `Credit has no detail.  Please credit one or more lines before attempting to save the transaction again.`,
          "error",
        );
        return;
      }

      saveModel.TaxTotal = 0;
      saveModel.Total = 0;

      details.forEach((detail) => {
        if (detail.InvoiceProductBatches) {
          let productBatches = [];
          let AlmondcoPayload = [];
          detail.InvoiceProductBatches.forEach((batchLine) => {
            if (batchLine.DespatchData) {
              if (!batchLine.CheckInclude) return;
              AlmondcoPayload.push({
                DespatchDate: batchLine.DespatchDate.toSaveDate(),
                PackedOnDate: batchLine.PackedOnDate.toSaveDate(),
                LotNo: batchLine.LotNo,
                PalletNo: batchLine.PalletNo,
                WorkOrderNo: batchLine.WorkOrder,
                CartonWeight: batchLine.CartonWeight,
                CartonQuantity: batchLine.CartonCreditQty,
                TotalWeight: batchLine.DespatchCreditWeight,
                DeliveryNote: batchLine.DeliveryNote,
                DeliveryNoteLineNo: batchLine.DeliveryNoteLineNo,
                InvoiceLineNo: batchLine.InvoiceLineNo,
                RecordId: batchLine.RecordID,
              });
            } else {
              let obj = {
                BatchNo: batchLine.BatchNo,
                SalesUMInvoiceConversion: batchLine.SalesUMInvoiceConversion,
                SupplierCode: batchLine.SupplierCode,
                StockUMBatchQty: calculateStockUMQty(
                  batchLine.ToCreditQty,
                  batchLine.SalesUMInvoiceConversion,
                ),
                SalesUMBatchQty: batchLine.ToCreditQty,
              };

              if (batchLine.ToCreditQty != 0) productBatches.push(obj);
            }
          });

          detail.InvoiceProductBatches = productBatches;
          if (this.almondcoQCData) {
            detail.AlmondcoWriteDespatchData = {
              ItemCode: detail.ItemCode,
              // ItemDescription: detail.ItemDescription,
              // RecordId: "00000000-0000-0000-0000-000000000000",
              AlmondcoWriteDespatchDataDetails: AlmondcoPayload,
            };
          }
        }

        saveModel.TaxTotal = saveModel.TaxTotal + detail.TaxLineTotal;
        saveModel.Total = saveModel.Total + detail.LineTotal.roundNumber(2);
      });

      saveModel.TaxTotal = saveModel.TaxTotal.roundNumber(2);
      saveModel.Total = saveModel.Total.roundNumber(2);

      saveModel.InvoiceCreditDetails = details;
      saveModel.ScreenName = "Credit Note";
      saveModel.ResupplyOrder = saveModel.ResupplyOrder ? "Y" : "N";
      // saveModel.ResupplyOrder = ResupplyOrder

      (saveModel.DateChanged = headerData.DateChanged
        ? new Date(headerData.DateChanged).toISOString().replace("Z", "")
        : null),
        (this.setLoading = true);
      await TransactionService.saveInvoiceCredit(saveModel)
        .then((res) => {
          this.$notify(
            `Credit # ${res.data.Code} for Invoice # ${res.data.OriginalInvoiceCode} saved successfully`,
            "success",
          );
          this.setIgnoreRouteChangeConfirmation();
          this.loaded = false;
          var query = undefined;
          if (this.baseView.query && this.baseView.query.from)
            query = {
              from: this.baseView.query.from,
            };
          this.$router
            .push({
              path: `/credit-invoice/review/${res.data.Code}`,
              query: query,
            })
            .then((res) => {
              this.setLoading = false;
              if (res) this.initialized();
            });
        })
        .catch((error) => {
          this.$store.dispatch("ui/setServerError", {
            error: error,
            title: "Credit Invoice save failed",
          });
          this.setLoading = false;
        });
    },
    changeInclude() {
      if (
        !this.$refs["invoice-credit"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ]
      )
        return;
      var refInstance =
        this.$refs["invoice-credit"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      var checkBox = refInstance.element();
      var getInstance = CheckBox.getInstance(checkBox);
      let gridItems = this.getDataContext("gcDataGrid");
      var items = gridItems.filter((x) => x.CheckInclude == true);

      if (items.length == 0) this.BulkInclude = false;
      else if (items.length == gridItems.length) this.BulkInclude = true;
      else this.BulkInclude = undefined;

      getInstance.option("value", this.BulkInclude);
    },
    updateCheckStockWriteOffBulk() {
      if (
        !this.$refs["invoice-credit"].$refs["transactionGrid"].$refs[
          "cx-CheckStockWriteOff"
        ]
      )
        return;

      var refInstance =
        this.$refs["invoice-credit"].$refs["transactionGrid"].$refs[
          "cx-CheckStockWriteOff"
        ].getSeletcAllRef().instance;
      var checkBox = refInstance.element();
      var getInstance = CheckBox.getInstance(checkBox);
      let gridItems = this.getDataContext("gcDataGrid");
      var items = gridItems.filter((x) => x.CheckStockWriteOff == true);

      var checkStockWriteOff = false;
      if (items.length == 0) checkStockWriteOff = false;
      else if (items.length == gridItems.length) checkStockWriteOff = true;
      else checkStockWriteOff = undefined;

      getInstance.option("value", checkStockWriteOff);
    },
    async setDateInValidation() {
      let startDateResult =
        await InvoiceCreditService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];

        if (
          this.DateIn.min == undefined ||
          this.DateIn.min <
            new Date(accountingPeriod.StartDate.replace("Z", ""))
        )
          this.DateIn.min = new Date(
            accountingPeriod.StartDate.replace("Z", ""),
          );
      }
      let endDateResult =
        await InvoiceCreditService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.DateIn.max = new Date(accountingPeriod.EndDate.replace("Z", ""));
      }
    },
  },
  watch: {
    dataChangedIndex() {
      this.changeInclude();
    },
  },
};
</script>

<style lang="scss">
.invoice-credit {
  .css-v2.transaction-screen
    .data-grid-details
    .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand):is(.dx-master-detail-cell) {
    padding-left: 70px !important;
  }
}
</style>
